import styled from 'styled-components';
import { IconButton } from '../../../../Components/Buttons';
import { colors } from '../../../../globalStyles';
import { PERSISTENCE_COLOR, WELLBEING_COLOR } from '../AssessmentIndex/AssessmentIndex.constants';
import { SeverityTone } from './AssessmentFlags.types';

export const FlagsHeaderDiv = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  margin: 0 2px 16px;
`;

export const FlagsTitle = styled.h2`
  margin: 0;
  color: ${colors.text};
  font-size: 24px;
  font-weight: 400;
`;

export const FlagsTableDiv = styled.div`
  margin: 0 2px;
  overflow-x: auto;
  overflow-y: hidden;
  border: 1px solid ${colors.grey.lightBorder};
  border-radius: 12px;
`;

export const FlagsTable = styled.table<{ $minWidth: string }>`
  width: 100%;
  min-width: ${({ $minWidth }) => $minWidth};
  border-collapse: collapse;
  table-layout: fixed;
  text-align: left;
  background-color: ${colors.white};

  th {
    padding: 15px 16px;
    color: ${colors.secondary};
    background-color: ${colors.greyBg};
    font-size: 14px;
    font-weight: 600;
  }

  th:first-child {
    width: 45%;
  }

  th:nth-child(2) {
    width: 24%;
  }

  th:nth-child(3) {
    width: 31%;
  }

  td {
    padding: 14px 16px;
    border-top: 1px solid ${colors.grey.lightBorder};
    color: ${colors.text};
    font-size: 15px;
    vertical-align: middle;
  }
`;

export const FlagNameTd = styled.td`
  font-weight: 700;
`;

export const SeverityTd = styled.td<{ $tone: SeverityTone }>`
  color: ${({ $tone }) =>
    $tone === 'severe'
      ? colors.danger
      : $tone === 'watch'
      ? colors.secondary
      : colors.brandAlt} !important;
  font-weight: 700;
`;

export const EmptyStateDiv = styled.div`
  min-height: 42px;
  color: ${colors.grayText};
  font-size: 14px;
  line-height: 1.5;
`;

export const SortHeaderButton = styled(IconButton)`
  color: inherit;
  font: inherit;
`;

export const FlagToggleButton = styled(IconButton)`
  align-items: center;
  display: flex;
  gap: 10px;
  text-align: left;
  width: 100%;
`;

export const CollapsedPhraseDiv = styled.div`
  color: ${colors.grayText};
  font-size: 13px;
  font-weight: 400;
  margin-top: 2px;
`;

const EXPANDED_ROW_BG = '#f3f4fc';

export const ExpandedRowTr = styled.tr`
  background-color: ${EXPANDED_ROW_BG};

  td {
    border-top: none;
    padding-top: 0;
  }
`;

export const ExpandedHighlightTr = styled.tr`
  background-color: ${EXPANDED_ROW_BG};
`;

export const FlagDetailCardDiv = styled.div`
  background-color: ${colors.white};
  border: 1px solid ${colors.grey.lightBorder};
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  gap: 14px;
  margin: 0 0 6px 26px;
  padding: 16px 20px;
`;

export const FlagDetailHeadingDiv = styled.div`
  color: ${colors.text};
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.05em;
  margin-bottom: 4px;
  text-transform: uppercase;
`;

export const FlagDetailTextDiv = styled.div`
  color: ${colors.text};
  font-size: 14px;
  font-weight: 400;
  line-height: 1.5;
`;

export const SourceQuestionsUl = styled.ul`
  color: ${colors.text};
  font-size: 14px;
  line-height: 1.5;
  margin: 0;
  padding-left: 20px;
`;

export const ContributionPairDiv = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`;

const contributionColor = ({ $index }: { $index: 'wellbeing' | 'persistence' }) =>
  $index === 'wellbeing' ? WELLBEING_COLOR : PERSISTENCE_COLOR;

export const ContributionBadgeDiv = styled.div<{ $index: 'wellbeing' | 'persistence' }>`
  min-width: 118px;
  border: 1px solid ${props => contributionColor(props)};
  border-radius: 6px;
  overflow: hidden;
  text-align: center;
`;

export const ContributionHeaderDiv = styled.div<{ $index: 'wellbeing' | 'persistence' }>`
  background-color: ${props => contributionColor(props)};
  color: ${colors.white};
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.06em;
  padding: 2px 8px;
  text-transform: uppercase;
`;

export const ContributionBodyDiv = styled.div<{
  $index: 'wellbeing' | 'persistence';
  $muted?: boolean;
}>`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  background-color: ${colors.white};
  color: ${props => contributionColor(props)};
  font-size: 12px;
  font-weight: 600;
  padding: 4px 8px;
  text-transform: ${({ $muted }) => ($muted ? 'uppercase' : 'none')};
  white-space: nowrap;
`;
